var _a;
import { PluginKey } from 'prosemirror-state';
import { pluginFactory } from '../../utils/plugin-state-factory';
import reducer from './reducer';
export var mobileScrollPluginKey = new PluginKey('mobileScroll');
export var createPluginState = (_a = pluginFactory(mobileScrollPluginKey, reducer), _a.createPluginState), getPluginState = _a.getPluginState, createCommand = _a.createCommand;
//# sourceMappingURL=plugin-factory.js.map